/**
 * Created by Christof Sander on 27.09.2016.
 */

module.exports = {
	extends: [
		'/',
		'base',
		'trees',
		'tree'
	],

	config: {
		treeConfig: {
			plugins: [
				'types',
				'checkbox'
			],
			core: {
				data:       undefined,
				multiple:   true
			},
			checkbox: {
				three_state: false,
				cascade: 'down+undetermined'
			}
		}
	}
};
